import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentMatterLedger: null,
};

const ledgerLinksSlice = createSlice({
  name: "ledgerLinks",
  initialState,
  reducers: {
    setMatterLedgerLink: (state, action) => {
      state.currentMatterLedger = action.payload;
    },
    clearMatterLedgerLink: (state) => {
      state.currentMatterLedger = null;
    },
  },
});

const { setMatterLedgerLink, clearMatterLedgerLink } = ledgerLinksSlice.actions;

const ledgerLinksReducer = ledgerLinksSlice.reducer;

export { ledgerLinksReducer, setMatterLedgerLink, clearMatterLedgerLink };
